// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/set-password-request-schema',
  type: 'object',
  required: ['email', 'oldPassword', 'newPassword'],
  properties: {
    email: {
      type: 'string',
      format: 'email',
      minLength: 1,
    },
    oldPassword: {
      type: 'string',
      minLength: 6,
    },
    newPassword: {
      type: 'string',
      minLength: 6,
    },
  },
} as IJSONSchema;

export default schema;
